/** Обязательные UI-подсказки для действий движка (SPEC §8). */
export const ACTION_HINTS: Record<string, string[]> = {
  "telegram.set2faPassword": [
    "Приводит 2FA аккаунта к системному паролю (конфигурация сервера).",
  ],
  "telegram.terminateOtherSessions": [
    "Терминирует все сессии аккаунта, кроме текущей; инвалидированные клиенты восстанавливаются только повторным импортом.",
  ],
  "flow.broadcastEphemeral": [
    "text не должен содержать литеральную последовательность {{ — escape-синтаксиса в движке нет.",
    "Элементы chats — числовой id чата или @username; invite-ссылки (t.me/+…, joinchat/…) не поддерживаются и попадут в skipped.",
    "Параметр role («кто рассылает») и цель запуска цепочки — разные вещи.",
  ],
}
